import { SignIn } from "@clerk/clerk-react";

import { useSignupsOpen } from "../lib/onboarding";

/** While sign-up is closed, Clerk's "Don't have an account? Sign up" line is hidden. */
const NO_SIGN_UP_LINK = { elements: { footerAction: { display: "none" } } };

export const SignInPage = () => {
  const canSignUp = useSignupsOpen() === true;
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-paper px-4">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-muted">TalentForge</p>
        <h1 className="font-serif text-3xl text-ink">Growth Engine</h1>
      </div>
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        appearance={canSignUp ? undefined : NO_SIGN_UP_LINK}
      />
    </main>
  );
};
